import React from 'react';
import PropTypes from 'prop-types';

export const TwoLayersIcon = (({ width=48, height=48, color='#0083C6' }) => {
    return (
        <svg width={width} height={height} viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M25.2001 36.12C24.4801 36.68 23.4601 36.68 22.7401 36.12L10.4401 26.56C9.72011 26 8.72011 26 8.00011 26.56C6.98011 27.36 6.98011 28.9 8.00011 29.7L21.5201 40.22C22.9601 41.34 24.9801 41.34 26.4401 40.22L39.9601 29.7C40.9801 28.9 40.9801 27.36 39.9601 26.56L39.9401 26.54C39.2201 25.98 38.2201 25.98 37.5001 26.54L25.2001 36.12ZM26.4601 30.08L39.9801 19.56C41.0001 18.76 41.0001 17.2 39.9801 16.4L26.4601 5.87999C25.0201 4.75999 23.0001 4.75999 21.5401 5.87999L8.02011 16.42C7.00011 17.22 7.00011 18.78 8.02011 19.58L21.5401 30.1C22.9801 31.22 25.0201 31.22 26.4601 30.08Z' fill={color}/>
        </svg>
    );
});

TwoLayersIcon.displayName = 'TwoLayersIcon';
TwoLayersIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    color: PropTypes.string
};
